module.exports = __webpack_public_path__ + "img/Close.b9850eda.svg";